import { CardContent, Grid2 as Grid, Typography, Card } from "@mui/material"
import React from "react"
import { RightioWBSAPIModelsSPSpBookingGetLastJobResult, RightioWBSAPIModelsSPSpJobsGetJobDetailsResult } from "@utils/apis/wbs/endpoints"

const name = "EngineerCard"

type EngineerCardProps = {
    parent: string
    job?: RightioWBSAPIModelsSPSpBookingGetLastJobResult
    jobDetails: RightioWBSAPIModelsSPSpJobsGetJobDetailsResult | undefined
}

const EngineerCard: React.FC<EngineerCardProps> = ({ parent, job, jobDetails }) => {

    return (
        (< Card sx={{ mb: 1 }}>
            <CardContent>
                {jobDetails?.bookingUserName &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Booked By:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails.bookingUserName}</span></Typography>
                        </Grid>
                    </Grid>}
                {jobDetails?.allocatedBy &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Allocated By:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.allocatedBy}</span></Typography>
                        </Grid>
                    </Grid>}
                {jobDetails?.engineerId !== 0 &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Engineer ID:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.engineerId}</span></Typography>
                        </Grid>
                    </Grid>}
                {jobDetails?.engineerName !== ". ." ?
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Engineer Name:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.engineerName}</span></Typography>
                        </Grid>
                    </Grid> :
                    <Grid container>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "red" }}>Engineer Not Assigned!</span></Typography>
                        </Grid>
                    </Grid>
                }
                {jobDetails?.engineerTelephoneMobile && jobDetails?.engineerTelephoneMobile !== "07777777777" &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Engineer Mobile:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.engineerTelephoneMobile}</span></Typography>
                        </Grid>
                    </Grid>}
                {jobDetails?.coverage !== null &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Coverage:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.coverage}%</span></Typography>
                        </Grid>
                    </Grid>}
                {jobDetails?.callTypeDescription !== null &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Call Type:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.callTypeDescription}</span></Typography>
                        </Grid>
                    </Grid>}
            </CardContent>
        </Card >)
    );
}

EngineerCard.displayName = name

export default React.memo(EngineerCard)

